import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { OverlayItem, OverlayUploadUrlData } from '../types';

export function useOverlayDetails(maskId: string) {
  const { data: uploadUrlData, refetch: refetchUploadUrl } =
    useApiQuery<OverlayUploadUrlData>(`/overlays/reupload-url/${maskId}`, {
      queryKey: ['overlayDetailsUploadUrl'],
      initialData: null,
    });

  const { isFetching, data } = useApiQuery<OverlayItem>(`/overlays/${maskId}`, {
    queryKey: ['overlayDetails'],
    initialData: null,
  });

  const updateOverlayMutation = useApiMutation<OverlayItem>(
    '/overlays',
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    isFetching,
    uploadUrlData,
    details: data,
    refetchUploadUrl,
    updateOverlayMutation,
  } as const;
}
